import { createContext } from 'react';

import { useInfieldLogout } from '../../../hooks/use-infield-logout';
import { useIsDesktop } from '../../../hooks/useIsDesktop';
import { AppConfigView } from '../../../pages/app-config/app-config-view';
import { useIsAppConfiguratorQuery } from '../hooks/use-query/use-is-app-configurator-query';

export interface AppConfigErrorScreenContextInterface {
  useInfieldLogout: () => Pick<ReturnType<typeof useInfieldLogout>, 'logout'>;
  useIsDesktop: () => ReturnType<typeof useIsDesktop>;
  useIsAppConfiguratorQuery: () => Pick<
    ReturnType<typeof useIsAppConfiguratorQuery>,
    'data'
  >;
  AppConfigView: typeof AppConfigView;
}

export const defaultValue: AppConfigErrorScreenContextInterface = {
  useInfieldLogout,
  useIsDesktop,
  useIsAppConfiguratorQuery,
  AppConfigView,
};

export const AppConfigErrorScreenContext =
  createContext<AppConfigErrorScreenContextInterface>(defaultValue);
